import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import getFileExtension from "@insite/client-framework/Common/Utilities/getFileExtension";
import siteMessage from "@insite/client-framework/SiteMessage";
import clearForm from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/ClearForm";
import setIsBadFile from "@insite/client-framework/Store/Components/OrderUpload/Handlers/SetIsBadFile";
import setUploadLimitExceeded from "@insite/client-framework/Store/Components/OrderUpload/Handlers/SetUploadLimitExceeded";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { DatePickerPresentationProps } from "@insite/mobius/DatePicker";
import DynamicDropdown from "@insite/mobius/DynamicDropdown/DynamicDropdown";
import FileUpload, { FileUploadPresentationProps } from "@insite/mobius/FileUpload";
import { FormFieldStyle, FormInputWrapper } from "@insite/mobius/FormField";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import AlertTriangle from "@insite/mobius/Icons/AlertTriangle";
import Radio, { RadioComponentProps } from "@insite/mobius/Radio";
import RadioGroup, { RadioGroupProps, RadioGroupStyle } from "@insite/mobius/RadioGroup";
import Select, { SelectPresentationProps, SelectProps } from "@insite/mobius/Select";
import TextArea, { TextAreaProps } from "@insite/mobius/TextArea";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { formatPhoneNumber } from "@tFissco/Common/Utilities/formatPhoneNumber";
import { CallbackType, ErrorObjectType, InputObjectType, validate } from "@tFissco/Common/Utilities/validate";
import {
    FormErrorsStateType,
    intialErrorFormState,
    requestForQuoteValidatorConfig,
    ValidatorConfigType,
} from "@tFissco/Components/RequestForQuoteFormValidatorConfig";
import loadWarehouses from "@tFissco/Handlers/LoadWarehousesData";
import addRequestForQuoteFormFields from "@tFissco/Handlers/RequestForQuoteFormHandler";
import * as React from "react";
import { useRef } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const enum fields {
    label = "label",
    hintText = "hintText",
    isRequired = "isRequired",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.label]: string;
        [fields.hintText]: string;
        [fields.isRequired]: boolean;
    };
}

const mapDispatchToProps = {
    addRequestForQuoteFormFields,
    loadWarehouses,
};

type Props = OwnProps & ResolveThunks<typeof mapDispatchToProps>;

export interface RequestForQuoteFormStyles {
    formWrapper?: InjectableCss;
    mainGridContainer?: GridContainerProps;
    fullWidth?: InjectableCss;
    sectionHeading?: InjectableCss;
    userNameTextField?: TextFieldPresentationProps;
    customInputCss?: InjectableCss;
    submitGridItem?: GridItemProps;
    marginTop?: InjectableCss;
    submitButton?: ButtonPresentationProps;
    emailTextField?: TextFieldPresentationProps;
    deliveryTextField?: TextFieldPresentationProps;
    fromDate?: DatePickerPresentationProps;
    startDatePicker?: DatePickerPresentationProps;
    textArea?: TextAreaProps;
    hintMessage?: InjectableCss;
    fileUploader?: FileUploadPresentationProps;
    addRemove?: InjectableCss;
    fileuploadStyle?: InjectableCss;
    fileUploadWrapper?: InjectableCss;
    fileUploadHint?: InjectableCss;
    tableWrapper?: InjectableCss;
    qntField?: GridItemProps;
    productFormMobileView?: InjectableCss;

    creatAccountformSectionwrapper?: GridContainerProps;
    creatAccountformSectionTitleWrapper?: GridItemProps;
    creatAccountformSectionTitle?: TypographyProps;
    userGridContainer?: GridItemProps;
    creatAccountfileldLayout?: GridItemProps;
    chooseOption?: GridItemProps;
    chooseOptionOuterGrid?: GridItemProps;
    chooseOptionInnerGrid?: GridItemProps;
    titleOne: TypographyProps;
    titleTwo: TypographyProps;
    documentUploadNote?: TypographyProps;
    documentUploadNoteTitle?: TypographyProps;

    distanceUnitOfMeasureRadioGroup?: RadioGroupProps;
    radioGroupDropdown?: RadioGroupProps;
    radioPickupDropdown?: RadioComponentProps;
    radioDeliveryDropdown?: RadioComponentProps;
    selectDropdown: SelectPresentationProps;
}

export const requestForQuoteFormStyles: RequestForQuoteFormStyles = {
    formWrapper: {
        css: css`
            margin-top: 20px;
            margin-bottom: 20px;
            h4 {
                font-weight: 600;
            }
            .fullWidthForMobileDevices {
                > div {
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                null,
                                null,
                                css`
                                    width: 100% !important;
                                `,
                            ],
                            "max",
                        )}
                }
            }
            > div[class^="GridWrapper"] {
                margin-top: 10px;
                padding-left: 0;
                margin-bottom: 30px;
                > div[class^="GridOffset"] {
                    width: 100%;
                    margin: 0;
                }
                > div[class^="RadioStyle"] {
                    margin-top: 0;
                    border: 1px solid red;
                    > label[class^="TypographyStyle"] {
                        font-size: 13px;
                    }
                }
            }
        `,
    },
    fullWidth: {
        css: css`
            width: 100%;
            > div[class^="RadioGroupStyle"] {
                justify-content: flex-start;
                display: inline-block;
                > div[class^="RadioStyle"] {
                    margin-top: 0;
                    margin-right: 20px;
                    display: inline-block;
                    &:last-child {
                        margin-right: 0;
                    }
                    > label[class^="TypographyStyle"] {
                        font-size: 13px;
                    }
                }
            }
        `,
    },
    sectionHeading: {
        css: css`
            font-weight: bold;
            border-bottom: 2px solid #ef3742;
            padding: 9px;
            padding-left: 15px;
            width: 100%;
            background: #f8f9fa;
            margin-bottom: 25px;
            margin-top: 25px;
        `,
    },
    customInputCss: {
        css: css`
            width: calc(33.3333% - 20px);
            display: inline-block;
            vertical-align: top;
            margin-bottom: 20px;
            margin-right: 30px;
            &:nth-child(3n + 1) {
                margin-right: 0;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            width: 100%;
                            margin-right: 0;
                        `,
                    ],
                    "max",
                )}

            > div[class^="FormFieldStyle"] {
                position: relative;
                width: 90%;
                > label {
                    font-size: 13px;
                    position: absolute;
                    z-index: 1;
                    padding-left: 5px;
                    background-color: #fff;
                    display: inline-block;
                    width: auto;
                    left: 20px;
                }
                > div input[type="text"] {
                    font-size: 13px;
                }
                > div select {
                    font-size: 13px;
                }
                > div[class^="FormInputWrapper"] {
                    > input {
                        font-size: 13px;
                    }
                    > div {
                        > span {
                            font-size: 13px;
                        }
                    }
                }
            }
            > div[class^="TooltipWrapper"] {
                width: 10%;
                padding: 10px;
            }
        `,
    },
    submitGridItem: {
        width: 12,
        css: css`
            display: flex;
            justify-content: left;
            width: 100%;
            margin-block: 25px;
            flex-direction: column;
            gap: 30px;
        `,
    },
    marginTop: {
        css: css`
            margin-top: 15px;
        `,
    },
    submitButton: {
        css: css`
            margin-right: 10px;
            width: max-content;
        `,
    },
    tableWrapper: {
        css: css`
            overflow: auto;
        `,
    },
    hintMessage: {
        css: css`
            font-weight: normal;
            padding-left: 10px;
            font-size: 13px;
        `,
    },
    fileUploader: {
        buttonProps: {
            variant: "primary",
        },
    },
    addRemove: {
        css: css`
            text-align: right;
            margin-top: 30px;
        `,
    },
    fileUploadWrapper: {
        css: css`
            display: flex;
            align-items: flex-start;
            flex-direction: column;
            width: 100%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            display: block;
                        `,
                    ],
                    "max",
                )}
        `,
    },
    fileUploadHint: {
        css: css`
            font-size: 12px;
            display: flex;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column;
                    `,
                    css`
                        flex-direction: column;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    fileuploadStyle: {
        css: css`
            position: relative;
            width: 50%;
            margin-right: 10px;
            margin-top: 10px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            width: 100%;
                            margin-right: 0px;
                            margin-bottom: 10px;
                        `,
                    ],
                    "max",
                )}
            >div[class^="UploadWrapper"] {
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                display: block;
                                > label[class^="ButtonWrapper"] {
                                    margin: 5px 0 0 0;
                                }
                            `,
                        ],
                        "max",
                    )}
            }
            > span[class^="TypographyStyle"] {
                position: absolute;
                left: 100px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                position: relative;
                                left: 0;
                            `,
                        ],
                        "max",
                    )}
                font-size: 13px;
                padding-top: 4px;
            }
        `,
    },
    qntField: {
        width: [12, 12, 6, 6, 4],
        css: css`
            > ${FormFieldStyle} {
                > ${FormInputWrapper} {
                    input::-webkit-outer-spin-button,
                    input::-webkit-inner-spin-button {
                        -webkit-appearance: none;
                        -moz-appearance: none;
                        appearance: none;
                    }
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            null,
                            null,
                            css`
                                margin-top: 34px !important;
                            `,
                            css`
                                margin-top: 34px !important;
                            `,
                            null,
                        ])}
                }
            }
        `,
    },
    productFormMobileView: {
        css: css`
            [class^="GridItemStyle"] {
                padding: 6px;
            }
            [class^="GridOffset"] {
                margin: 0;
            }
            padding: 15px;
            &:nth-child(odd) {
                background: #f3f3f3;
            }
        `,
    },

    creatAccountformSectionwrapper: {
        css: css`
            background-color: ${getColor("secondary")};
            margin-bottom: 20px;
            border-radius: 10px;
            overflow: hidden;
            > ${GridOffset} {
                width: 100%;
                margin: 0px;
            }
        `,
    },
    creatAccountformSectionTitleWrapper: {
        width: 12,
        css: css`
            background: ${getColor("common.border")};
            padding: 11px 30px;
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
        `,
    },
    creatAccountformSectionTitle: {
        variant: "h5",
        css: css`
            margin-bottom: 0;
            font-family: "MontserratRegular";
            color: ${getColor("text.accent")};
            font-weight: 700 !important;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-size: 16px;
                    `,
                    css`
                        font-size: 16px;
                    `,
                    css`
                        font-size: 16px;
                    `,
                    css``,
                    null,
                ])}
        `,
    },
    userGridContainer: {
        width: [12, 12, 12, 12, 12],
        css: css`
            flex-wrap: wrap;
            display: flex;
        `,
    },
    creatAccountfileldLayout: {
        width: [12, 12, 6, 6, 4],
    },
    chooseOptionOuterGrid: {
        width: [12, 12, 6, 6, 4],
        css: css`
            flex-wrap: wrap;
            flex-direction: column;
        `,
    },
    chooseOptionInnerGrid: {
        width: 12,
        css: css`
            padding: 0;
            width: 100%;
            align-items: flex-start;
            position: relative;
            top: -10px;
            flex-direction: row;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column;
                    `,
                    css`
                        flex-direction: column;
                    `,
                    css`
                        flex-direction: column;
                        position: unset;
                        top: 0px;
                    `,
                    css`
                        flex-direction: column;
                        position: unset;
                        top: 0px;
                    `,
                    css`
                        align-items: flex-end;
                    `,
                ])}
            > ${TypographyStyle} {
                width: auto;
                color: #0e0e0e;
                font-size: 16px;
                text-transform: capitalize;
                font-weight: 600;
                font-family: MontserratRegular;
            }
            > ${RadioGroupStyle} {
                height: 34px;
                position: relative;
                top: -5px;
                width: auto;
            }
        `,
    },
    titleOne: {
        variant: "headerSecondary",
        size: 16,
        transform: "none",
        color: "text.accent",
    },
    titleTwo: {
        variant: "headerSecondary",
        size: 16,
        transform: "none",
        color: "text.accent",
        css: css`
            margin: 2rem 0rem;
        `,
    },
    documentUploadNote: {
        as: "p",
        css: css`
            margin: 10px 10px 0px 0px;
            font-size: 14px;
        `,
    },
    documentUploadNoteTitle: {
        css: css`
            display: inline-block;
            font-weight: 600;
        `,
    },
    distanceUnitOfMeasureRadioGroup: {
        css: css`
            display: inline-block;
            width: 100%;
            flex-direction: row;
            text-align: right;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    null,
                    null,
                    css`
                        position: relative;
                        right: 1rem;
                        bottom: 5.8rem;
                    `,
                ])}
            & > div {
                display: inline-flex;
                font-weight: 900;
                font-family: MontserratRegular;
                font-size: 16px;
                color: #0e0e0e;
            }
        `,
    },
    radioGroupDropdown: {
        css: css`
            display: inline-block;
            width: 100%;
            flex-direction: row;
            text-align: left;
            margin-left: -10px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    null,
                    null,
                    css`
                        text-align: right;
                        margin-left: 0px;
                    `,
                ])}
            & > div {
                display: inline-flex;
                font-weight: 900;
                font-family: MontserratRegular;
                font-size: 16px;
                color: #0e0e0e;
                margin-top: 0px !important;
                padding: 5px;
            }
        `,
    },
    selectDropdown: {
        cssOverrides: {
            formField: css`
                width: 100%;
            `,
        },
    },
};

interface RfqProduct {
    [x: string]: string | number | undefined;
    mpn?: string;
    mfrName?: string;
    quantity?: string;
    description?: string;
}

const styles = requestForQuoteFormStyles;
const emailRequiredFieldMessage = siteMessage("CreateNewAccountInfo_EmailAddress_Required");
const emailFieldMessage = siteMessage("CreateNewAccountInfo_EmailAddress_ValidEmail");
const emailRegexp = new RegExp("\\w+([-+.']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*");

const RequestForQuoteForm = ({ addRequestForQuoteFormFields, loadWarehouses }: Props) => {
    const [isLoading, setIsLoading] = React.useState(false);
    const [mfrName, setMfrName] = React.useState("");
    const [mpn, setMPN] = React.useState("");
    const [modelNumber, setModelNumber] = React.useState("");
    const [serialNumber, setSerialNumber] = React.useState("");
    const [quantity, setQuantity] = React.useState("");
    const [pickUpDelivery, setPickUpDelivery] = React.useState("-- Select Warehouse --");
    const [description, setDescription] = React.useState("");
    const [firstName, setFirstName] = React.useState("");
    const [lastName, setLastName] = React.useState("");
    const [companyName, setCompanyName] = React.useState("");
    const [jobTitle, setJobTitle] = React.useState("");
    const [country, setCountry] = React.useState("");
    const [accountNumber, setAccountNumber] = React.useState("");
    const [phone, setPhone] = React.useState("");
    const [isSubmitted, setIsSubmitted] = React.useState(false);
    const [emailError, setEmailError] = React.useState(emailRequiredFieldMessage);
    const [email, setEmail] = React.useState("");
    const [formErrors, setFormErrors] = React.useState<FormErrorsStateType>(intialErrorFormState);
    const [isButtonDisabled, setIsButtonDisabled] = React.useState(true);

    const fileUploadRef = useRef({ value: "" } as HTMLInputElement);
    const [incorrectFileExtension, setIncorrectFileExtension] = React.useState(false);
    const [file, setFile] = React.useState<any>(null);
    const [selectRadio, setSelectRadio] = React.useState("Pickup");
    const [fileErrorMsg, setFileErrorMsg] = React.useState("");
    const [allData, setAllData] = React.useState([]);
    const [dropdownErrorMessage, setDropdownErrorMessage] = React.useState("");
    const [countryErrorMessage, setCountryErrorMessage] = React.useState("");

    const firstNameChangeHandler = (input: HTMLInputElement) => {
        setFirstName(input.value);
        validateHandler(input);
    };
    const lastNameChangeHandler = (input: HTMLInputElement) => {
        setLastName(input.value);
        validateHandler(input);
    };
    const companyNameHandler = (input: HTMLInputElement) => {
        setCompanyName(input.value);
        validateHandler(input);
    };

    const titleChangeHandler = (input: HTMLInputElement) => {
        setJobTitle(input.value);
    };

    const validateCountry = (value: string) => {
        const errorMessage = !value ? "Country Required" : "";
        setCountryErrorMessage(errorMessage);
        return !errorMessage;
    };

    const handleCountryChange = (input: React.ChangeEvent<HTMLSelectElement>) => {
        setCountry(input.currentTarget.value);
        validateCountry(input.currentTarget.value);
    }

    const phoneChangeHandler = (input: HTMLInputElement) => {
        setPhone(formatPhoneNumber(input.value));
        validateHandler(input);
    };
    const emailChangeHandler = (input: HTMLInputElement) => {
        validateEmail(input.value);
        setEmail(input.value);
        validateHandler(input);
    };
    const validateEmail = (email: string) => {
        const errorMessage = !email ? emailRequiredFieldMessage : emailRegexp.test(email) ? "" : emailFieldMessage;
        setEmailError(errorMessage);
        return !errorMessage;
    };

    const accNumberChangeHandler = (input: HTMLInputElement) => {
        setAccountNumber(input.value);
    };

    const mfrNameChangeHandler = (input: HTMLInputElement) => {
        setMfrName(input.value);
    };
    const mpnChangeHandler = (input: HTMLInputElement) => {
        setMPN(input.value);
    };
    const modelNumberHandler = (input: HTMLInputElement) => {
        setModelNumber(input.value);
    };
    const serialNumberChangeHandler = (input: HTMLInputElement) => {
        setSerialNumber(input.value);
    };
    const quantityChangeHandler = (input: HTMLInputElement) => {
        setQuantity(input.value);
    };

    const descriptionChangeHandler = (input: HTMLTextAreaElement) => {
        setDescription(input.value);
    };
    const validateSubmitEnabled = () => {
        return !(
            countryErrorMessage
        );
    };
    const isSubmitEnabled = validateSubmitEnabled();

    const validateHandler = (
        input: HTMLInputElement | HTMLSelectElement | any,
        customValidation?: CallbackType,
    ): void => {
        const inputObject: InputObjectType = {
            name: input.name,
            value: input.value,
        };
        const validatorConfig = requestForQuoteValidatorConfig[input.name as keyof ValidatorConfigType];
        const isValidate: ErrorObjectType | undefined = validate(inputObject, validatorConfig, customValidation);

        if (isValidate === undefined) {
            delete formErrors[input.name as keyof FormErrorsStateType];
            setFormErrors(formErrors);
        } else {
            setFormErrors({
                ...formErrors,
                [input.name]: isValidate ? isValidate.errorMsg : isValidate,
            });
        }
        if (!validatorConfig.required && input.value === "") {
            delete formErrors[input.name as keyof FormErrorsStateType];
            setFormErrors(formErrors);
        }
        setIsButtonDisabled(validateSubmitDisabled(formErrors));
    };
    const submitHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
        const isCountryValid = validateCountry(country);

        if (!isCountryValid) {
            return scrollToFirstFormError();
        }
        if (!isSubmitted) {
            if (pickUpDelivery === "-- Select Warehouse --" || pickUpDelivery === "" || pickUpDelivery === "Pickup") {
                setDropdownErrorMessage("Warehouse required");
                setTimeout(() => {
                    scrollToFirstFormError();
                }, 0);
            } else {
                setIsLoading(true);
                addRequestForQuoteFormFields({
                    firstName,
                    lastName,
                    company: companyName,
                    jobTitle,
                    phone,
                    emailAddress: email,
                    accountNumber,
                    mfrName,
                    mpn,
                    modelNumber,
                    serialNumber,
                    quantity,
                    pickUpDelivery,
                    description,
                    attachment: file,
                    country,
                    onSuccess: () => {
                        clearForm();
                        setIsLoading(false);
                        setIsSubmitted(true);
                        window.location.href = "/ThankYou";
                    },
                });
            }
        }
    };

    const scrollToFirstFormError = () => {
        const firstErrorElement = document.querySelector("[data-test-selector='undefined-error']");
        if (firstErrorElement) {
            const formFieldParent = firstErrorElement.closest("[class*='FormFieldStyle']");
            if (!formFieldParent) {
                return;
            }
            const { top } = formFieldParent.getBoundingClientRect();
            window.scrollTo({
                top: top + window.pageYOffset - 250,
                left: 0,
                behavior: "smooth",
            });
        }
    };

    const validateSubmitDisabled = (errorsState: FormErrorsStateType) => {
        return Object.keys(errorsState).length !== 0;
    };

    const validateSelectedFile = (
        uploadedFileSize: { size: number },
        callback: { (value: React.SetStateAction<string>): void; (arg0: string): void },
    ) => {
        const MAX_FILE_SIZE = 5120; // 5MB
        const fileSizeKiloBytes = uploadedFileSize.size / 1024;
        const maxSize = fileSizeKiloBytes > MAX_FILE_SIZE;
        if (maxSize) {
            callback("File size is greater than maximum limit");
        }
    };

    const fileChangeHandler = (event: React.ChangeEvent<any>) => {
        const uploadedFile = event.target.files[0];
        setFile(uploadedFile);
        setFileErrorMsg("");
        if (uploadedFile) {
            const fileExtension = getFileExtension(uploadedFile.name);
            const incorrectFileExtension =
                ["xls", "xlsx", "csv", "png", "jpg", "docx", "doc", "pdf"].indexOf(fileExtension) === -1;
            if (incorrectFileExtension) {
                setFileErrorMsg("Invalid file format");
                return;
            }
            // setIncorrectFileExtension(incorrectFileExtension);
            setIsBadFile({ isBadFile: incorrectFileExtension });
            setUploadLimitExceeded({ uploadLimitExceeded: false });
            validateSelectedFile(uploadedFile, setFileErrorMsg);
        }
    };

    const onSuccessHandler = () => {};
    React.useEffect(() => {
        loadWarehouses({
            onSuccess: onSuccessHandler,
            onComplete(resultProps: any) {
                if (resultProps.apiResult) {
                    this.onSuccess?.();
                    setAllData(resultProps.apiResult?.warehouses);
                }
            },
        });
    }, []);

    const pickUpDeliveryChangeHandler = (input: HTMLInputElement) => {
        setPickUpDelivery("Delivery");
        validateHandler(input.value);
    };

    const handleRadioOptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        if (value === "Pickup") {
            setSelectRadio("Pickup");
            setPickUpDelivery("Pickup");
        } else {
            setPickUpDelivery("Delivery");
            setSelectRadio("Delivery");
        }
    };

    const handleWareHouseChange: SelectProps["onChange"] = event => {
        setPickUpDelivery(event.target.value);
        setDropdownErrorMessage("");
        if (
            event.target.value === "-- Select Warehouse --" ||
            event.target.value === "" ||
            event.target.value === "Pickup"
        ) {
            setDropdownErrorMessage("Warehouse required");
        } else {
            setDropdownErrorMessage("");
        }
    };

    return (
        <StyledWrapper {...styles.formWrapper}>
            <Typography as="p" {...styles.titleOne}>
                {siteMessage("RequestForQuote_start_para_first")}
            </Typography>
            <Typography as="p" {...styles.titleTwo}>
                {siteMessage("RequestForQuote_start_para_second")}
            </Typography>
            <GridContainer {...styles.mainGridContainer}>
                <StyledWrapper {...styles.fullWidth}>
                    <form autoComplete="off">
                        <GridContainer {...styles.creatAccountformSectionwrapper}>
                            <GridItem {...styles.creatAccountformSectionTitleWrapper}>
                                <Typography {...styles.creatAccountformSectionTitle}>
                                    {translate("Product Information")}
                                </Typography>
                            </GridItem>

                            <GridItem {...styles.userGridContainer}>
                                <GridItem {...styles.creatAccountfileldLayout}>
                                    <TextField
                                        label={translate("Brand/Manufacturer Name")}
                                        value={mfrName}
                                        data-test-selector="mfr_Name"
                                        onChange={e => mfrNameChangeHandler(e.currentTarget)}
                                        name="mfrName"
                                    />
                                </GridItem>
                                <GridItem {...styles.creatAccountfileldLayout}>
                                    <TextField
                                        label={translate("Manufacturing Part Number")}
                                        value={mpn}
                                        data-test-selector="mpn"
                                        onChange={e => mpnChangeHandler(e.currentTarget)}
                                        name="mpn"
                                    />
                                </GridItem>
                                <GridItem {...styles.creatAccountfileldLayout}>
                                    <TextField
                                        label={translate("Model Number")}
                                        value={modelNumber}
                                        data-test-selector="modelNumber"
                                        onChange={e => modelNumberHandler(e.currentTarget)}
                                        name="modelNumber"
                                    />
                                </GridItem>
                                <GridItem {...styles.creatAccountfileldLayout}>
                                    <TextField
                                        label={translate("Serial Number")}
                                        value={serialNumber}
                                        data-test-selector="serialNumber"
                                        onChange={e => serialNumberChangeHandler(e.currentTarget)}
                                        name="serialNumber"
                                    />
                                </GridItem>
                                <GridItem {...styles.qntField}>
                                    <TextField
                                        label={translate("Quantity")}
                                        value={quantity}
                                        type="number"
                                        data-test-selector="quantity"
                                        onChange={e => quantityChangeHandler(e.currentTarget)}
                                        name="quantity"
                                        min="0"
                                    />
                                </GridItem>
                                <GridItem {...styles.chooseOptionOuterGrid}>
                                    <GridItem {...styles.chooseOptionInnerGrid}>
                                        <Typography>
                                            {siteMessage("RequestForQuote_product_information_select_an_option")}
                                        </Typography>

                                        <RadioGroup
                                            {...styles.radioGroupDropdown}
                                            name="pickUpDelivery"
                                            value={selectRadio}
                                            onChangeHandler={handleRadioOptionChange}
                                        >
                                            <Radio {...styles.radioPickupDropdown} value="Pickup">
                                                {translate("Pick Up")}
                                            </Radio>
                                            <Radio {...styles.radioDeliveryDropdown} value="Delivery">
                                                {translate("Delivery")}
                                            </Radio>
                                        </RadioGroup>
                                    </GridItem>
                                    {selectRadio === "Delivery" && (
                                        <TextField
                                            {...styles.deliveryTextField}
                                            value={pickUpDelivery}
                                            data-test-selector="pickUpDelivery"
                                            onChange={e => pickUpDeliveryChangeHandler(e.currentTarget)}
                                            onBlur={e => validateHandler(e.currentTarget)}
                                            name="pickUpDelivery"
                                            disabled
                                        />
                                    )}
                                    {selectRadio === "Pickup" && (
                                        <Select
                                            {...styles.selectDropdown}
                                            value={pickUpDelivery || ""}
                                            name="pickUpDelivery"
                                            onChange={handleWareHouseChange}
                                            error={dropdownErrorMessage}
                                        >
                                            <option value="">{translate("-- Select Warehouse --")}</option>
                                            {allData &&
                                                allData.map((warehouse: any) => (
                                                    <option key={warehouse.id} value={warehouse.description}>
                                                        {warehouse.description}
                                                    </option>
                                                ))}
                                        </Select>
                                    )}
                                </GridItem>
                                <GridItem {...styles.creatAccountfileldLayout}>
                                    <TextArea
                                        {...styles.textArea}
                                        label={siteMessage(
                                            "RequestForQuote_product_information_detailed_item_description",
                                        )}
                                        value={description}
                                        data-test-selector="description"
                                        onChange={e => descriptionChangeHandler(e.currentTarget)}
                                    />
                                </GridItem>
                            </GridItem>
                        </GridContainer>

                        <GridContainer {...styles.creatAccountformSectionwrapper}>
                            <GridItem {...styles.creatAccountformSectionTitleWrapper}>
                                <Typography {...styles.creatAccountformSectionTitle}>
                                    {translate("Contact Information")}
                                </Typography>
                            </GridItem>

                            <GridItem {...styles.userGridContainer}>
                                <GridItem {...styles.creatAccountfileldLayout}>
                                    <TextField
                                        label={translate("First Name")}
                                        value={firstName}
                                        data-test-selector="rfq_firstName"
                                        onChange={e => firstNameChangeHandler(e.currentTarget)}
                                        onBlur={e => validateHandler(e.currentTarget)}
                                        error={!!formErrors.firstName && formErrors.firstName}
                                        name="firstName"
                                        iconProps={{
                                            color: "danger",
                                            src: formErrors.firstName ? AlertTriangle : undefined,
                                        }}
                                        required
                                    />
                                </GridItem>
                                <GridItem {...styles.creatAccountfileldLayout}>
                                    <TextField
                                        label={translate("Last Name")}
                                        value={lastName}
                                        data-test-selector="rfq_lastName"
                                        onChange={e => lastNameChangeHandler(e.currentTarget)}
                                        onBlur={e => validateHandler(e.currentTarget)}
                                        error={!!formErrors.lastName && formErrors.lastName}
                                        name="lastName"
                                        iconProps={{
                                            color: "danger",
                                            src: formErrors.lastName ? AlertTriangle : undefined,
                                        }}
                                        required
                                    />
                                </GridItem>
                                <GridItem {...styles.creatAccountfileldLayout}>
                                    <TextField
                                        label={translate("Company Name")}
                                        value={companyName}
                                        data-test-selector="rfq_companyName"
                                        onChange={e => companyNameHandler(e.currentTarget)}
                                        onBlur={e => validateHandler(e.currentTarget)}
                                        error={!!formErrors.companyName && formErrors.companyName}
                                        name="companyName"
                                        iconProps={{
                                            color: "danger",
                                            src: formErrors.companyName ? AlertTriangle : undefined,
                                        }}
                                        required
                                    />
                                </GridItem>
                                <GridItem {...styles.creatAccountfileldLayout}>
                                    <TextField
                                        label={translate("Job Title")}
                                        value={jobTitle}
                                        data-test-selector="job_Title"
                                        onChange={e => titleChangeHandler(e.currentTarget)}
                                        error={!!formErrors.title && formErrors.title}
                                        name="jobTitle"
                                    />
                                </GridItem>
                                <GridItem {...styles.creatAccountfileldLayout}>
                                    <Select
                                            {...styles.selectDropdown}
                                            value={country}
                                            label={translate("Country")}
                                            required
                                            name="selectCountry"
                                            onChange={e => handleCountryChange(e)}
                                            error={countryErrorMessage}
                                        >
                                            <option value="">{translate("-- Select Country --")}</option>
                                                <option key="United States" value="United States">
                                                        {translate("United States")}
                                                </option>
                                        </Select>
                                </GridItem>

                                <GridItem {...styles.creatAccountfileldLayout}>
                                    <TextField
                                        label={translate("Phone Number")}
                                        type="tel"
                                        list="autocompleteOff"
                                        autoComplete="new-password"
                                        aria-autocomplete="none"
                                        value={phone}
                                        data-test-selector="rfq_phone"
                                        onChange={e => phoneChangeHandler(e.currentTarget)}
                                        onBlur={e => validateHandler(e.currentTarget)}
                                        error={!!formErrors.phone && formErrors.phone}
                                        name="phone"
                                        iconProps={{
                                            color: "danger",
                                            src: formErrors.phone ? AlertTriangle : undefined,
                                        }}
                                        required
                                    />
                                </GridItem>

                                <GridItem {...styles.creatAccountfileldLayout}>
                                    <TextField
                                        {...styles.emailTextField}
                                        type="email"
                                        label={translate("Email ID")}
                                        value={email}
                                        data-test-selector="rfq_email"
                                        onChange={e => emailChangeHandler(e.currentTarget)}
                                        onBlur={e => validateHandler(e.currentTarget)}
                                        error={!!formErrors.email && formErrors.email}
                                        name="email"
                                        iconProps={{
                                            color: "danger",
                                            src: formErrors.email ? AlertTriangle : undefined,
                                        }}
                                        required
                                    />
                                </GridItem>
                                <GridItem {...styles.creatAccountfileldLayout}>
                                    <TextField
                                        label={translate("Account Number (if Applicable)")}
                                        value={accountNumber}
                                        data-test-selector="account_Number"
                                        onChange={e => accNumberChangeHandler(e.currentTarget)}
                                        name="accountNumber"
                                    />
                                </GridItem>
                            </GridItem>
                        </GridContainer>
                    </form>
                </StyledWrapper>

                <StyledWrapper {...styles.fileUploadWrapper}>
                    <StyledWrapper {...styles.fileuploadStyle}>
                        <FileUpload
                            {...styles.fileUploader}
                            inputRef={fileUploadRef}
                            fileName={file?.name || ""}
                            accept=".xls,.xlsx,.csv,.docx,.doc,.pdf,.jpg,.png"
                            label={translate("Upload a File")}
                            labelPosition="top"
                            error={fileErrorMsg}
                            onFileChange={fileChangeHandler}
                        />
                    </StyledWrapper>
                    <StyledWrapper {...styles.fileUploadHint}>
                        <Typography {...styles.documentUploadNote}>
                            <Typography {...styles.documentUploadNoteTitle}> Accepted file types: </Typography>
                            .xls, .xlsx, .csv, .docx, .doc, .pdf, .jpg, .png
                        </Typography>
                        <Typography {...styles.documentUploadNote}>
                            <Typography {...styles.documentUploadNoteTitle}> Max file size: </Typography> 5 MB.
                        </Typography>
                    </StyledWrapper>
                </StyledWrapper>
            </GridContainer>
            <StyledWrapper {...styles.submitGridItem}>
                <Button
                    {...styles.submitButton}
                    onClick={submitHandler}
                    disabled={isButtonDisabled || isLoading || !isSubmitEnabled} 
                    data-test-selector="requestForQuote_submitButton"
                >
                    {translate("Submit Quote Request")}
                </Button>
                <Typography>{siteMessage("RequestForQuote_required_fields")}</Typography>
            </StyledWrapper>
        </StyledWrapper>
    );
};
const widgetModule: WidgetModule = {
    component: connect(null, mapDispatchToProps)(RequestForQuoteForm),
    definition: {
        group: "Contact Us",
        icon: "FormField",
        fieldDefinitions: [],
    },
};
export default widgetModule;
